$(document).ready(function() {
  "use strict";

  function setWidthFollowScreen(selector,compare,sub1,dad,sub2) {
    if ($(window).width() >= 1200 ) {
      var width=$(compare).width()-sub1;
      $(selector).css({'width':function(){return width+'px'},'left':function(){
        var left_val=(($(window).width()-width)/2)-$(dad).position().left;
        console.log($(dad).position().left)
        console.log($(window).width())
        console.log(($(window).width()-width)/2)
        return left_val-sub2+'px';
      }})
    }
    $(window).resize(function(){
      if ($(window).width() >= 1200 ) {
        var width=$(compare).width()-sub1;
        $(selector).css({'width':function(){return width+'px'},'left':function(){
          var left_val=-($(dad).position().left-(($(window).width()-width)/2));
          return left_val-sub2+'px';
        }})
      }
    })
  }


  function removeCookie() {
    jQuery.cookie('michelie_popup', '1', {expires: 0, path:'/', domain: 'michelie-store-demo.myshopify.com' });
  }

  function newsLetterPopup() {
    var link='';
    if (!jQuery.cookie('michelie_popup') || jQuery.cookie('michelie_popup') == null) { 
      jQuery(window).load(function() {
        setTimeout($('.js-popup-v2').removeClass('d-none'), 300 * 1000);
        $('.js-popup-v2 .js-close-popup, .js-popup-v2 .js-bg-overlay-v2').click(function(e) {
          if ($('.js-form-check-input').prop('checked')) {
            e.preventDefault(); 
            jQuery.cookie('michelie_popup', '1', {expires: 1, path:'/', domain: link });
          }
          $('.js-popup-v2').addClass('d-none');
        });
      });
    }
  }

  //   (function (MegaMenu, $) {
  //   'use strict';

  //   const $dom = {};

  //   const cacheDom = () => {
  //     $dom.body = $('body');
  //     $dom.mainMenuItem = $('[data-menu-section]');
  //     $dom.megaMenuLink = $('[data-menu-link-id]');
  //     $dom.megaMenuTiles = $('[data-menu-tiles-id]');
  //   };

  //   const bindUIActions = function () {
  //     $dom.mainMenuItem.on('mouseover',function (event) {
  //       const $self = $(this);
  //       const section = $self.attr('data-menu-section');
  //       const menuGroup = $self.attr('data-menu-item-group');
  //       if (event.type == 'mouseover' && !$self.is('active')) {
  //         $(`[data-menu-section][data-menu-item-group="${menuGroup}"]`).removeClass('active');
  //         $self.addClass('active');
  //         $(`[data-dropdown-menu][data-dropdown-menu-group="${menuGroup}"].active`).removeClass('active');
  //         $(`[data-dropdown-menu="${section}"][data-dropdown-menu-group="${menuGroup}"]`).addClass('active');
  //       }
  //     });

  //     $dom.megaMenuLink.on('mouseover', function() {
  //       const activeTileSelector = '[data-menu-tiles-id="'+ $(this).attr('data-menu-link-id') +'"]';
  //       $dom.megaMenuTiles.hide();
  //       $dom.megaMenuTiles.filter(activeTileSelector).css('display', 'flex');
  //     });
  //   };

  //   MegaMenu.init = function () {
  //     cacheDom();
  //     bindUIActions();
  //   };

  // }(window.MegaMenu = window.MegaMenu || {}, jQuery));

  function megamenuHover() {
    $('.js-hover').children().each(function(){
      $(this).on('mouseover',function(){
        if ($('#'+$(this).children().attr('data-hover')).hasClass('d-none')) {
          $('.js-hover').next().find('.d-flex').removeClass('d-flex position-absolute').addClass('d-none');
          $('#'+$(this).children().attr('data-hover')).addClass('d-flex').removeClass('d-none');

        }
      })
    })
  }


  function slidePopup() {
    $('.js-close-popup').on('click', function() {
      $('.js-popup-v1').removeClass('active');
      $('.js-bg-overlay-v1').removeClass('active');
    });

    $('.js-bg-overlay-v1').on('click', function() {
      $(this).removeClass('active');
      $('.js-popup-v1').removeClass('active');
    });
  }

  function slideMenuMobile() {
    $('.js-btn-menu-mobile').on('click', function() {
      $('.js-menu-mobile').toggleClass('active');
      $('.js-background-overlay').toggleClass('active');
      $('.js-mobile-content').toggleClass('active');
      $('.menu-mobile-close').toggleClass('active');
      $(this).toggleClass('active');
    });
    $('.js-background-overlay').on('click', function() {
      $(this).removeClass('active');
      $('.js-menu-mobile').removeClass('active');
      $('.js-mobile-content').removeClass('active');
      $('.menu-mobile-close').removeClass('active');
      $('.js-btn-menu-mobile').removeClass('active');

    });

    $('.js-btn-menu-nav').on('click', function() {
      $('.js-mobile-content').addClass('active');
      $(this).addClass('active');
      $('.js-btn-login').removeClass('active');
      $('.js-account-login').removeClass('active');

    });
    $('.js-btn-login').on('click', function() {
      $('.js-account-login').addClass('active');
      $(this).addClass('active');
      $('.js-btn-menu-nav').removeClass('active');
      $('.js-mobile-content').removeClass('active');
      $('.js-custom-login').removeClass('d-none');
    });

    $(window).resize(function(){
      if ($(window).width() >= 1200 ) {
        $('.js-menu-mobile').removeClass('active');
        $('.js-background-overlay').removeClass('active');
        $('.js-mobile-content').removeClass('active');
        $('.menu-mobile-close').removeClass('active');
        $(this).removeClass('active');
      }
    })
  }

  function slideMobileSearch() {
    $('.js-menu-mobile-search').on('click', function() {
      $('.js-mobile-search').toggleClass('active');
    });
    $('.js-close-mobile-search').on('click', function() {
      $('.js-mobile-search').removeClass('active');
    });
  }

  //   function slideMiniCartMobile() {
  //     $('.js-minicart-mobile').on('click', function() {
  //       $('.js-minicart-content-mobile').toggleClass('active');
  //       $('.js-bg-overlay-minicart').toggleClass('active');
  //     });

  //     $('.js-minicart-mobile-close').on('click', function() {
  //       $('.js-minicart-content-mobile').removeClass('active');
  //       $('.js-bg-overlay-minicart').removeClass('active');
  //     });

  //     $('.js-bg-overlay-minicart').on('click', function() {
  //       $(this).removeClass('active');
  //       $('.js-minicart-content-mobile').removeClass('active');
  //     });
  //   }

  function slideMiniCart() {

    $( '.js-minicart' ).on( "click", function() {
      $('.js-minicart-content').addClass('active');
      $('.js-bg-minicart').addClass('active');
    });

    $( '.js-minicart-close' ).on( "click", function() {
      setTimeout(function(){
        $('.js-minicart-content').removeClass('active');

        $('.js-bg-minicart').removeClass('active');
      })
    });
    $( '.js-bg-minicart').on( "click", function() {
      $(this).removeClass('active');
      $('.js-minicart-content').removeClass('active');

    });
  }

  function switchDropAngle() {
    $('.mobile-link').on('click', function() {
      $(this).toggleClass('active');
    });
  }

  function switchLoginRegisterForm() {
    $('.js-back-to-login').on('click', function() {
      $('.js-custom-login').removeClass('d-none');
      $('.js-custom-login-res').addClass('d-none');
    });
    $('.js-create-an-account').on('click', function() {
      $('.js-custom-login-res').removeClass('d-none');
      $('.js-custom-login').addClass('d-none');
    });
  }

  //   function switchMenuMobile() {
  //     if ($('header').hasClass('header-v2')) {
  //       $('.header-middle').removeClass('d-none');
  //       $('.menu-mobile').find('.menu').addClass('menu-v2');
  //       $('.menu-mobile').find('.menu-hamburger').addClass('menu-hamburger-v2');
  //       $('.menu-mobile-tab').find('.box-tab-nav').addClass('box-tab-nav-v2');
  //     }
  //     else {
  //       $('.header-middle').addClass('d-none');
  //       $('.menu-mobile').find('.menu').removeClass('menu-v2');
  //       $('.menu-mobile').find('.menu-hamburger').removeClass('menu-hamburger-v2');
  //       $('.menu-mobile-tab').find('.box-tab-nav').removeClass('box-tab-nav-v2');
  //     }

  //   }

  function headerFixedMobile() {
    if ($(window).width() < 1200) {
      $('.menu-mobile').css({'position':'fixed','top':'0','left':'0','right':'0','z-index':'99'})
      $('.js-header').css({'padding-top':function(){
        return $('.menu-mobile').height() + 'px';
      }})
    } else {
      $('.js-header').css({'padding-top':'0'})
    }
    $(window).resize(function(){
      if ($(window).width() < 1200) {
        $('.menu-mobile').css({'position':'fixed','top':'0','left':'0','right':'0','z-index':'99'})
        $('.js-header').css({'padding-top':function(){
          return $('.menu-mobile').height() + 'px';
        }})
      } else {
        $('.js-header').css({'padding-top':'0'})
      }
    })
  }

  $.fn.fixed = function(){
    var location, scroll, height,
        e = this
    location = e.offset().top
    height = e.outerHeight()
    if ($(window).scrollTop() > location) {
      e.parent().css('height',height)
      e.addClass('hd-fixed')
    } else {
      e.removeClass('hd-fixed')
    }
    $(window).on('scroll',function(){
      scroll = $(window).scrollTop()
      if (scroll > location) {
        e.parent().css('height',height)
        e.addClass('hd-fixed')
      } else {
        e.removeClass('hd-fixed')
      }
    })
    $(window).resize(function(){
      e.removeClass('hd-fixed')
      location = e.offset().top
      height = e.outerHeight()
      if ($(window).scrollTop() > location) {
        e.parent().css('height',height)
        e.addClass('hd-fixed')
      } else {
        e.removeClass('hd-fixed')
      }
      $(window).on('scroll',function(){
        scroll = $(window).scrollTop()
        if (scroll > location) {
          e.parent().css('height',height)
          e.addClass('hd-fixed')
        } else {
          e.removeClass('hd-fixed')
        }
      })
    })
  }

  function slideShowV1() {
    $('.js-slideshow-v1').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      fade: true,
      infinite: true,
      asNavFor: '.js-sub-slideshow',
      adaptiveHeight: true
    });
    $('.js-sub-slideshow').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js-slideshow-v1',
      focusOnSelect: true,
      vertical: true,
      arrows: false
    });
  }

  function slideShowV2() {
    $('.js-slideshow-v2').slick({
      dots: false,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 5000,
      infinite: true,
      adaptiveHeight: true
    });
  }

  function slideShowV3() {
    $('.js-slide-v3').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      centerMode: true,
      centerPadding: '0px',
      focusOnSelect: true,
      prevArrow: '<button type="button" class="carousel-prev"><span class="fa fa-angle-left"></span></button>',
      nextArrow: '<button type="button" class="carousel-next"><span class="fa fa-angle-right"></span></button>'
    });
  }

  function slideShowV4() {
    $('.js-slideshow-v4').slick({
      dots: false,
      arrows: true,
      autoplay: false,
      adaptiveHeight: true,
      asNavFor: '.js-slideshowInfo-v4',
      prevArrow: '<button type="button" class="slick-brand-prev ti-arrow-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-arrow-right"></button>',
    });
    $('.js-slideshowInfo-v4').slick({
      dots: false,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      asNavFor: '.js-slideshow-v4'
    });

  }

  function slideShowV5() {
    $('.js-slideshow-v5').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-long-arrow-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-long-arrow-right"></i></button>', 
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });                  
  }

  function testimonialV1() {
    $('.js-testimonial-v1').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      adaptiveHeight: true
    });
  }

  function slideShowSidebarCollection() {
    $('.js-slideshow-collection').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      adaptiveHeight: true
    });
  }

  function FilterSidebarColecllectionInRight() {
    $( '.js-filter' ).on( "click", function() {
      $(this).toggleClass('d-none')
      $('.js-close-filter').toggleClass('d-block')

      $('.js-filter-popup').toggleClass('active');
      $('.js-bg-filter').toggleClass('active');
    });

    $( '.js-close-filter' ).on( "click", function() {
      $(this).addClass('d-none')
      $(this).removeClass('d-block')
      $('.js-filter').removeClass('d-none')
      $('.js-filter').addClass('d-block')

      $('.js-filter-popup').removeClass('active');
      $('.js-bg-filter').removeClass('active');
    });


    $( '.js-bg-filter').on( "click", function() {
      $(this).removeClass('active');
      $('.js-filter-popup').removeClass('active');
      $('.js-close-filter').removeClass('d-block')

      $('.js-filter').removeClass('d-none')
      $('.js-filter').addClass('d-block')

    });
  }

  function brandV1() {
  $('.js-brand-v1').slick({
    arrows: true,
    infinite: true,
    centerMode: true,
    centerPadding: '0px',
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left" aria-label="Previous brand"></button>',
    nextArrow: '<button type="button" class="slick-brand-next ti-angle-right" aria-label="Next brand"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });

  
  $('.js-brand-v1').on('afterChange', function(event, slick, currentSlide) {
    $('.slick-slide').each(function() {
      var $slide = $(this);
      if ($slide.attr('aria-hidden') === 'true') {
        $slide.attr('tabindex', '-1');
        $slide.find('a, button, input, select, textarea').attr('tabindex', '-1');
      } else {
        $slide.attr('tabindex', '0');
        $slide.find('a, button, input, select, textarea').attr('tabindex', '0');
      }
    });
  });

  
  $('.js-brand-v1').trigger('afterChange');
}



  function serviceResponsiveV1() {
    $('.js-service-responsive').slick({
      arrows: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }

  function serviceResponsiveProduct() {
    $('.js-service-product').slick({
      arrows: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }

  function slideCountdown() {
    $('.js-quick-view').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: true,
      infinite: false,
      asNavFor: '.js-product-countdown'
    });
    $('.js-product-countdown').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js-quick-view',
      dots: false,
      arrows: true,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-up"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-down"></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false,
            arrows: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: false,
            arrows: false,
            verticalSwiping: false
          }
        }
      ]
    });

    $('.section-countdown-v2 .js-countdown-info').eq(0).addClass('active');
    $('.js-quick-view').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      $('.section-countdown-v2 .js-countdown-info').removeClass('active');
      $('.section-countdown-v2 .js-countdown-info').eq(mySlideNumber).addClass('active');
    });
  }

  function slideProductDetail() {
    $('.js-mid').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dot: false,
      fade: true,
      infinite: false,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      asNavFor: '.js-product-thumbnail'
    });
    $('.js-product-thumbnail').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js-mid',
      dots: false,
      arrows: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false
          }
        }
      ]
    });
    $('.js-mid-bt').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dot: false,
      fade: true,
      infinite: false,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      asNavFor: '.js-product-thumbnail-bt'
    });
    $('.js-product-thumbnail-bt').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js-mid-bt',
      dots: false,
      arrows: false,
      infinite: false,
      focusOnSelect: true
    });
  }

  function tabProductDetail() {
    $('.js-list-tag-detail').children().each(function(){
      $(this).on('click',function(){
        $('.js-detail-tab-content').find('.active').removeClass('active');
        $('.js-detail-tab-content').parent().next().find('.active').removeClass('active');
        $('#'+ $(this).children().attr('data-toggle')).addClass('active');
      })
    })
  }



  function backToTop() {
    var btn = $('#back-to-top');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 50) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });
  }

  function productV1() {
    $('.js-product-v1').slick({
      arrows: false,
      dots: false,
      autoplay: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        }
      ]
    });
  }

  function productV8() {
    $('.js-product-v8').slick({
      arrows: false,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }

  function slideRelatedProduct() {
    $('.js-related-product').slick({
      arrows: false,
      dots: false,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }

  //   function tabProduct(section) {
  //     $(section).find('ul').each(function(){
  //       $(this).children().eq(0).addClass('active');
  //     });
  //     $(section).find('.product-grid').each(function(){
  //       $(this).children().each(function(){
  //         $(this).addClass('position-absolute');
  //       })
  //       $(this).children().eq(0).removeClass('position-absolute').addClass('position-static active')
  //     })
  //     $(section).find('li').each(function(){
  //       $(this).on('click',function(){
  //         if (!$(this).hasClass('active')) {
  //           $(this).parentsUntil(section).find('.active').removeClass('active');
  //           $(this).addClass('active');
  //           $(this).parentsUntil($(section)).eq(-1).addClass('xxx')
  //           var link = $(this).find('a').attr('data-target')
  //           setTimeout(function(){
  //             $(section).find('.position-static').removeClass('position-static').addClass('position-absolute');
  //             $('.xxx').find($('#'+ link)).removeClass('position-absolute').addClass('position-static active');
  //             $('.xxx').removeClass('xxx');
  //           },300)
  //         }
  //       })
  //     })
  //   }

  function tabProductV4() {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
      e.target
      e.relatedTarget
      $('.js-tab-product-v4').slick('setPosition');
    });
  }

  function tabProductV6() {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
      e.target
      e.relatedTarget
      $('.js-tab-product-v6').slick('setPosition');
    });
  }

  function slideProductV6() {
    setTimeout(function(){
      $('.js-tab-product-v6').each(function(){
        var dots = $(this).attr('data-dots');
        if (dots == 'true') {
          dots = true;
        } else {
          dots = false;
        }
        var arrow = $(this).attr('data-arrows');
        if (arrow == 'true') {
          arrow = true;
        } else {
          arrow = false;
        }
        $(this).slick({
          arrows: arrow,
          dots: dots,
          autoplay: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
          nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            }
          ]
        });
      })
    }, 500);
  }


  function brandContactUs() {
    $('.js-brand-contactus').slick({
      arrows: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-brand-prev ti-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next ti-angle-right"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    });
  }

  function serviceResponsiveContactUs() {
    $('.js-contact-service').slick({
      arrows: false,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    });
  }

  function maxHeight() {
    jQuery(function() {
      jQuery('.maxHeight').matchHeight();
    });
  }


  function setHeightSelector(selector,selector2) {
    $(selector).css({'height':function(){
      return $(selector2).height() + 'px';
    }})
    $(window).resize(function(){
      $(selector).css({'height':function(){
        return $(selector2).height() + 'px';
      }})

    })
  }

  function video() {
    $('[data-fancybox]').fancybox({
      youtube : {
        controls : 0,
        showinfo : 0
      },
      vimeo : {
        color : 'f00'
      }
    });
  }

  function openSearch() {
    $('.js-search').on('click',function(){
      $('.js-search-box').toggleClass('active')
    })
  }
  
  function openCurrency() {
    $('.menu-mobile-tab .currency').on('click',function(){
      $('#currencies').slideToggle(300)
    })
  }

  openCurrency();
  megamenuHover();
  slidePopup();
  slideMenuMobile();
  slideMobileSearch();
  //   slideMiniCartMobile();
  slideMiniCart();
  switchDropAngle();
  switchLoginRegisterForm();
  //   switchMenuMobile();
  headerFixedMobile();

  slideShowV1();
  slideShowV2();
  slideShowV3();
  slideShowV4();
  slideShowV5();
  testimonialV1();
  slideShowSidebarCollection();
  FilterSidebarColecllectionInRight();
  brandV1();
  serviceResponsiveV1();
  serviceResponsiveProduct();
  slideCountdown();
  slideProductDetail();
  tabProductDetail();
  backToTop();
  productV1();
  productV8();
  slideRelatedProduct();
  openSearch();
  tabProductV6();
  slideProductV6();
  brandContactUs();
  serviceResponsiveContactUs();
  maxHeight();
  newsLetterPopup();
  setWidthFollowScreen('.js-dropmenu','.js-compare','30','.js-dad','15');
  setHeightSelector('.js-cate','.js-slideshow-v2');
  video();


  if ($('header').hasClass('header-v1')) {
    
    $('.js-fixed').fixed()
    
  }
  if ($('header').hasClass('header-v2')) {
    
  }
  if ($('header').hasClass('header-v3')) {
    
  }
  if ($('header').hasClass('header-v4')) {
    
  }
  if ($('header').hasClass('header-v5')) {
    
  }

});

